// extracted by mini-css-extract-plugin
module.exports = {"link":"_9d2893d","sizeExtraSmall":"_44b06aa","sizeSmall":"_5e9c9f9","sizeDefault":"_a982c94","sizeLarge":"_33aa32c"};